import { render, staticRenderFns } from "./examineCategorySelect.vue?vue&type=template&id=56b24c0c&scoped=true"
import script from "./examineCategorySelect.vue?vue&type=script&lang=js"
export * from "./examineCategorySelect.vue?vue&type=script&lang=js"
import style0 from "./examineCategorySelect.vue?vue&type=style&index=0&id=56b24c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b24c0c",
  null
  
)

export default component.exports